import { Entity } from '@contact/upgrade';

export enum RecipientSearchType {
  BY_EMAIL,
  BY_CONTACT_ID,
  BY_DIRECTORY,
  DIRECT,
}

export interface IRecipient extends Entity {
  contactId: string; // Id of the contact
  uuid: string; // UUID of the contact
  id: string; // eptica iasID of the contact
  lastname: string; // lastname of the contact
  firstname: string; // firstname of the contact
  email: string; // Email address of the contact
}
